import { Button, Icon, Link } from '@chakra-ui/react';
import { NormalText, Microsoft } from '@carafe/components';
import { strings } from '@localisation';

interface Props {
  url: string;
}

export const MicrosoftSignInButton = ({ url }: Props): JSX.Element => {
  return (
    <Button
      width="100%"
      border="1px solid"
      borderColor="gray.300"
      colorScheme="white"
      color="gray.900"
      fontSize="0.75rem"
      as={Link}
      href={url}
      isDisabled={!url.length}
    >
      <Icon as={Microsoft} w={5} h={5} />
      <NormalText ml="0.375rem" text={strings.social.microsoft} />
    </Button>
  );
};
